import { ItemList } from '../../orm'

class AdminOutgoingVoiceServiceProviderList extends ItemList {
    getEntityKey() {
        return "admin/outgoing_voice_service_provider"
    }
}

export const adminOutgoingVoiceServiceProviderList = new AdminOutgoingVoiceServiceProviderList("admin_outgoing_voice_service_provider__default")
